import { useCallback, useMemo } from "react";
import { Dropdown } from "antd";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { useNavigate } from "react-router";
import { ShopOutlined } from "@ant-design/icons";
import useSelectedCompany from "hooks/useSelectedCompany";
import { useSelector } from "react-redux";
import { companiesSelector } from "appredux/selectors";
import { selectedCompanySelector } from "appredux/selectors";

const CompanySelector = () => {
  const navigate = useNavigate();
  const companies = useSelector(companiesSelector);
  const selectedCompany = useSelector(selectedCompanySelector);
  const { onSelectCompany } = useSelectedCompany();

  const onChangeCompany = useCallback(
    (key) => {
      // store.set("app.endpoint", key);
      // Axios.defaults.baseURL = generateBaseUri();
      // dispatch(resetData());
      // dispatch(setConfig({ endpoint: key }));
      // queryClient.clear();
      // onSelectCompany
      const findCompany = companies.find((row) => row.endpoint === key);
      if (findCompany) {
        onSelectCompany(findCompany);
      }
    },
    [companies, onSelectCompany]
  );

  const changeCompany = useCallback(
    ({ key }) => {
      if (key === "list") {
        navigate("/companies");
      } else if (key === "add") {
        navigate("/companies/add");
      } else if (selectedCompany?.endpoint !== key) {
        onChangeCompany(key);
      }
    },
    [onChangeCompany, selectedCompany, navigate]
  );

  const menuItems = useMemo(() => {
    const items = companies.map((item) => ({
      key: item.endpoint,
      label: item.name,
      icon: <ShopOutlined />,
    }));
    // if (companies.length > 1) {
    //   items.push({
    //     key: "divider",
    //     type: "divider",
    //   });
    //   items.push({
    //     key: "list",
    //     label: t("companies.company_list"),
    //     icon: <UnorderedListOutlined />,
    //   });
    // } else {
    //   items.push({
    //     key: "add",
    //     label: t("companies.add_company"),
    //     icon: <PlusOutlined />,
    //   });
    // }
    return items;
    // return (
    //   <Menu
    //     selectedKeys={[selectedCompany?.endpoint]}
    //     onClick={changeCompany}
    //     items={items}
    //   />
    // );
  }, [companies]);

  return (
    <Dropdown
      overlayClassName="pt-0"
      placement="bottomRight"
      menu={{
        items: menuItems,
        selectedKeys: [selectedCompany?.endpoint],
        onClick: changeCompany,
      }}
      trigger={["click"]}
    >
      <div className="flex flex-row items-center gap-1 cursor-pointer">
        {selectedCompany?.name ? (
          <>
            <span className="font-medium uppercase">
              {selectedCompany?.name}
            </span>
            <MdOutlineArrowDropDown />
          </>
        ) : null}
      </div>
    </Dropdown>
  );
};

export default CompanySelector;
